const profile = {
    name: 'Jméno',
    avatar: 'Profilový obrázek',
    givenName: 'Křestní jméno',
    familyName: 'Příjmení',
    middleName: 'Druhé jméno',
    fullname: 'Celé jméno',
    nickname: 'Přezdívka',
    preferredUsername: 'Preferované uživatelské jméno',
    profile: 'Profil',
    website: 'Webová stránka',
    gender: 'Pohlaví',
    birthdate: 'Datum narození',
    zoneinfo: 'Časové pásmo',
    locale: 'Region',
    address: {
        formatted: 'Adresa',
        streetAddress: 'Název ulice',
        locality: 'Město',
        region: 'Kraj',
        postalCode: 'PSČ',
        country: 'Země',
    },
    gender_options: {
        female: 'Žena',
        male: 'Muž',
        prefer_not_to_say: 'Nechci uvádět',
    },
    checkbox_value: {
        checked: 'Ano',
        unchecked: 'Ne',
    },
    avatar_upload: {
        upload: 'Nahrát',
        remove: 'Odebrat',
        uploading: 'Nahrávání...',
        hint: 'Doporučená velikost 1:1, maximálně {{limit}}.',
        error_file_type: 'Typ souboru musí být {{extensions}}.',
        error_file_size: 'Velikost souboru nesmí překročit {{limit}}.',
        error_storage_not_configured: 'Fotografii se nepodařilo nahrát. Zkuste to znovu později.',
        error_upload: 'Nepodařilo se nahrát fotografii. Zkuste to znovu.',
        error_save: 'Nepodařilo se uložit vaši fotku. Zkuste to prosím znovu.',
        crop_title: 'Oříznout fotku',
        zoom: 'Přiblížení',
        error_crop: 'Oříznutí obrázku se nezdařilo. Zkuste to znovu.',
    },
};
export default Object.freeze(profile);
